'use client'

import React from 'react'
import { ArticleCard, type Article } from './index'

export const ArticleCardClient = ({
  title,
  categoryName,
  tags,
  postDateText,
  summary,
  url,
  mainImage,
  youTubeId,
  onCardClick,
}: Article) => (
  <div className="u-height-100" onClick={() => onCardClick && onCardClick()}>
    <ArticleCard
      title={title}
      categoryName={categoryName}
      tags={tags}
      postDateText={postDateText}
      summary={summary}
      url={url}
      mainImage={mainImage}
      youTubeId={youTubeId}
    />
  </div>
)
